import React, { useEffect, useState, useRef } from 'react';
import {
  Box, Grid, Button, TextField, Typography, Stepper, Step, StepLabel,
  FormControl, InputLabel, Select, MenuItem, Link, IconButton, Input, OutlinedInput, DialogContent,
} from '@mui/material';
import {
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  NavigateNext as NavigateNextIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CancelPresentation as CancelPresentationIcon,
  LocalPrintshop as PrintIcon,
} from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { isValidPinCode } from "../../../lib/regexHelpers";
import {
  getAreaByPin
} from "../../../Api/PropertyMst/Api";
import '../../../index.css'
import { FormLabel, RadioGroup, FormControlLabel, Radio, StepConnector } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from "../../../lib/axios";
import { toast, ToastContainer } from 'react-toastify';
import { ConfirmDialog } from '../../ReusablePopup/CustomModel';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { InputAdornment } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { format } from 'date-fns';
import moment from 'moment';
import Report from '../../../atoms/ReportFolder/Report';
import { useReactToPrint } from 'react-to-print';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import CustomAutocomplete from '../../AutoComplete/AutoComplete';
import { z } from 'zod';
import axiosInstance from '../../../lib/axios';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const steps = ['Personal Info', 'Family Info', 'Work Info', 'KYC Document'];

const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  '& .MuiStepConnector-line': {
    borderColor: '#e0e0e0',
    borderTopWidth: 3,
    borderRadius: 1,
    marginBottom: '20px',
  },
}));

const CustomStepIcon = styled('div')(({ theme, ownerState }) => ({
  width: 40,
  height: 40,
  border: '3px solid',
  borderColor: ownerState.active ? '#7c3aed' : '#e0e0e0',
  borderRadius: '50%',
  backgroundColor: 'transparent',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: ownerState.active ? '#7c3aed' : '#999',
  fontSize: '1.2rem',
  fontWeight: 'bold',
}));

const CustomStepLabel = styled(StepLabel)({
  flexDirection: 'column',
  '& .MuiStepLabel-labelContainer': {
    marginTop: '5px',
  },
});

const formSchema = z.object({
  firstName: z.string().min(1, "First Name is required"),
  PinId: z.string().length(6, "Pin Code must be 6 digits")
});

const StepperForm = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [mode, setMode] = useState('view');
  const [jobTitle, setJobTitle] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [course, setCourse] = useState([]);
  const [semester, setSemester] = useState([]);
  const [source, setSource] = useState([])
  const location = useLocation();
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [photo, setPhoto] = useState('');
  const [residentId, setResidentId] = useState(-1);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchTerms, setSearchTerms] = useState({});
  const [IsFromTransaction, setIsFromTransaction] = useState(false);
  const [rows, setRows] = useState([]);
  const [sites, setSites] = useState([]);
  const [area, setArea] = useState([]);
  const [selectedRowForEdit, setSelectedRowForEdit] = useState(null);
  const [PartyCat, setPartyCat] = useState([]);
  const [Relation, setRelation] = useState([]);
  const [lastId, setLastId] = useState(0);
  const [DataForPrint, setDataForPrint] = useState({});
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });
  const [showCalendar, setShowCalendar] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [docTypeName, setDocTypeName] = useState([]);
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [selectedDocType, setSelectedDocType] = useState({ Id: '', Name: '' });
  const [conFlag, setConFlag] = useState()
  const [selectedAreaCountryId, setSelectedAreaCountryId] = useState('');
  const [openImageModal, setOpenImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageName, setSelectedImageName] = useState('');
  const [zoom, setZoom] = useState(1);
  const [formData, setFormData] = useState(
    {
      DBFLAG: "",
      FirstName: '',
      MidName: '',
      LastName: '',
      Gender: 'Female',
      BillType: 'I',
      Profession: 'S',
      ResidentType: 'I',
      Dob: moment().format('DD/MM/YYYY'),
      Mobile: '',
      SourceId: '',
      Name: "",
      SourceName: '',
      RefName: '',
      Email: '',
      AadharNo: '',
      PanNo: '',
      Pincode: '',
      CityName: '',
      StateName: '',
      CountryName: '',
      PinId: '',
      PermanentAddr: '',
      CurrentAddr: '',
      Photo: '',
      AltMob: '',
      EmgMob: '',
      BillToPartyId: '',
      InstituteID: '',
      CourseId: '',
      JobTitle: '',
      AccountNo: '',
      BankName: '',
      BeneficiaryNm: '',
      IFSCCode: '',
      LastHostle: '',
      WorkEmail: '',
      WorkPhone: '',
      SemesterId: '',
      Status: '',
      Remark: '',
      CreatedBy: '',
      UpdatedBy: '',
      mstResidentDtlEntities: [{
        DBFLAG: "",
        ResidentDtlId: "",
        ResidentId: "",
        ImgPath: "",
        ImgName: "",
        RelationTitle: "Mr",
        RelativeName: "",
        RelationName: "",
        RelationId: "",
        Mobile: "",
        Email: "",
        Age: "",
        Occupation: "",
        Address: "",
        CountryId: ""
      }],
      mstResidentDocEntities: [{
        DBFLAG: "",
        MstResidentDocId: "",
        ResidentId: "",
        DocTypeId: "",
        Remark: "",
        DocTypeName: "",
        ImgName: "",
        ImgPath: "",
        DocNo: "",
        DocExpDt: ""
      }],
    });

  useEffect(() => {

    if (location.state && location.state?.ResidentId) {
      setResidentId(location.state.ResidentId);
      fetchResidentData(location.state?.ResidentId, "R");
      setMode('view');
    } else {

      if (location.state?.IsFromTransaction) {
        setFormData(prev => ({ ...prev, Mobile: location.state.Mobile }));
        setIsFromTransaction(true);
      }

      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  useEffect(() => {
    const fetchConFlag = async () => {
      try {
        const response = await axiosInstance.post('CountryMst/getAllCountryMasterDashBoard', {
          start: 1,
          PageSize: 1,
          SearchText: ""
        });

        if (response.data.Status === 0) {
          setConFlag(response.data.Data);
        } else {
          setConFlag([]);
        }
      } catch (error) {
        toast.error("Error while fetching country flag.");
      }
    };
    fetchConFlag();
  }, [])

  const columns = [
    { id: 'RelationTitle', label: 'Title', minWidth: 50 },
    { id: 'RelativeName', label: 'Name', minWidth: 170 },
    { id: 'RelationName', label: 'Relation', minWidth: 170 },
    { id: 'Occupation', label: 'Occupation', minWidth: 170 },
    { id: 'Mobile', label: 'Mobile', minWidth: 100 }
  ];

  const fetchResidentData = async (id, flag) => {
    try {
      const response = await axios.post(`ResidentMst/RetriveResidentMstAll`, {
        ResidentId: parseInt(id),
        Flag: flag,
        Mobile: ""
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {

        const residentData = response.data.Data.MstResidentList[0];
        const firstFamilyMember = residentData.mstResidentDtlEntities && residentData.mstResidentDtlEntities.length > 0
          ? residentData.mstResidentDtlEntities[0]
          : null;
        const countryIdFromResponse = firstFamilyMember?.CountryId ? String(firstFamilyMember.CountryId) : '';
        const formattedDob = residentData.Dob ? moment(residentData.Dob).format('DD/MM/YYYY') : '';
        setDataForPrint(residentData);
        setFormData({
          ResidentId: residentData.residentId,
          DBFLAG: residentId ? 'U' : 'A',
          FirstName: residentData.FirstName || '',
          MidName: residentData.MidName || '',
          LastName: residentData.LastName || '',
          ResidentType: residentData.ResidentType || '',
          Gender: residentData.Gender || '',
          Dob: formattedDob,
          Mobile: residentData.Mobile || '',
          Email: residentData.Email || '',
          SourceId: residentData.SourceId ? residentData.SourceId.toString() : '',
          SourceName: residentData.SourceName,
          Name: residentData.AreaName,
          RefName: residentData.RefName,
          AadharNo: residentData.AadharNo || '',
          PanNo: residentData.PanNo || '',
          PinId: residentData.PinId ? residentData.PinId.toString() : '',
          Pincode: residentData.Pincode || '',
          PermanentAddr: residentData.PermanentAddr || '',
          CurrentAddr: residentData.CurrentAddr || '',
          Photo: residentData.Photo || '',
          AltMob: residentData.AltMob || '',
          EmgMob: residentData.EmgMob || '',
          CountryName: residentData.CountryName || '',
          StateName: residentData.StateName || '',
          CityName: residentData.CityName || '',
          BillToPartyId: residentData.BillToPartyId ? residentData.BillToPartyId.toString() : '',
          InstituteID: residentData.InstituteID ? residentData.InstituteID.toString() : '',
          CourseId: residentData.CourseId ? residentData.CourseId.toString() : '',
          JobTitle: residentData.JobTitle ? residentData.JobTitle.toString() : '',
          LastHostle: residentData.LastHostle || '',
          AccountNo: residentData.AccountNo || '',
          BankName: residentData.BankName || '',
          BeneficiaryNm: residentData.BeneficiaryNm || '',
          IFSCCode: residentData.IFSCCode || '',
          WorkEmail: residentData.WorkEmail || '',
          WorkPhone: residentData.WorkPhone || '',
          BillType: residentData.BillType || '',
          Profession: residentData.Profession || '',
          SemesterId: residentData.SemesterId.toString() || '',
          Status: residentData.Status || '1',
          Remark: residentData.Remark || '',
          CreatedBy: residentData.CreatedBy ? residentData.CreatedBy.toString() : '',
          UpdatedBy: residentData.UpdatedBy ? residentData.UpdatedBy.toString() : '',
          mstResidentDtlEntities: response.data.Data.MstResidentList[0].mstResidentDtlEntities !== undefined ? [{
            DBFLAG: residentId ? 'R' : 'A',
            ResidentDtlId: residentData.mstResidentDtlEntities[0].ResidentDtlId || '',
            ResidentId: residentData.mstResidentDtlEntities[0].ResidentId || '',
            ImgPath: residentData.mstResidentDtlEntities[0].ImgPath || '',
            ImgName: residentData.mstResidentDtlEntities[0].ImgName || '',
            RelationTitle: residentData.mstResidentDtlEntities[0].RelationTitle || '',
            RelativeName: residentData.mstResidentDtlEntities[0].RelativeName || '',
            RelationName: residentData.mstResidentDtlEntities[0].RelationName || '',
            Mobile: residentData.mstResidentDtlEntities[0].Mobile || '',
            CountryId: countryIdFromResponse || '',
            Email: residentData.mstResidentDtlEntities[0].Email || '',
            Age: residentData.mstResidentDtlEntities[0].Age || '',
            Occupation: residentData.mstResidentDtlEntities[0].Occupation || '',
            Address: residentData.mstResidentDtlEntities[0].Address || ''
          }] : [{
            DBFLAG: residentId ? 'R' : 'A',
            ResidentDtlId: '',
            ResidentId: '',
            ImgPath: '',
            ImgName: '',
            RelationTitle: '',
            RelativeName: '',
            RelationName: '',
            Mobile: '',
            CountryId: '',
            Email: '',
            Age: '',
            Occupation: '',
            Address: ''
          }],
          mstResidentDocEntities: response.data.Data.MstResidentList[0].mstResidentDocEntities !== undefined
            && residentData.mstResidentDocEntities.length > 0
            ? response.data.Data.MstResidentList[0].mstResidentDocEntities.map(doc => ({
              DBFLAG: residentId ? 'R' : 'A',
              MstResidentDocId: residentData.mstResidentDocEntities.MstResidentDocId || '',
              ResidentId: doc.ResidentId || '',
              DocTypeId: doc.DocTypeId || '',
              Remark: doc.Remark || '',
              DocTypeName: doc.DocTypeName || '',
              ImgPath: doc.ImgPath || '',
              DocNo: parseInt(doc.DocNo, 10) || 0
            }))
            : [{
              DBFLAG: residentId ? 'R' : 'A',
              MstResidentDocId: '',
              ResidentId: '',
              DocTypeId: '',
              Remark: '',
              DocTypeName: '',
              ImgPath: '',
              DocNo: ''
            }]
        });

        setIsFormDisabled(true);
        setResidentId(residentData?.ResidentId);
        let arrOfdata = residentData.mstResidentDtlEntities !== undefined && residentData.mstResidentDtlEntities.length > 0
          ? residentData.mstResidentDtlEntities
          : [];
        setRows(arrOfdata);
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch resident data');
      }
    } catch (error) {
      toast.error('Error fetching resident data. Please try again.');
    }
  };

  // const handleImageClick = (imgPath, docTypeName) => {
  //   if (imgPath) {
  //     setSelectedImage(replaceImgPath(imgPath));
  //     setSelectedImageName(docTypeName || 'KYC Document');
  //     setOpenImageModal(true);
  //   }
  // };

  const handleClose = () => {
    setOpenImageModal(false);
    setZoom(1);
  };

  const handleImageClick = (imgPath, docTypeName) => {
    if (!imgPath) return;

    const extension = imgPath.split('.').pop().toLowerCase();

    if (extension === 'pdf') {
      let fixedPath = imgPath;

      // Fix missing double slash
      if (fixedPath.startsWith('http:/') && !fixedPath.startsWith('http://')) {
        fixedPath = fixedPath.replace('http:/', 'https://');
      } else if (!fixedPath.startsWith('http://') && !fixedPath.startsWith('https://')) {
        fixedPath = 'https://' + fixedPath;
      }

      window.open(fixedPath, '_blank');
    } else {
      setSelectedImage(replaceImgPath(imgPath));
      setSelectedImageName(docTypeName || 'KYC Document');
      setOpenImageModal(true);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClick = () => {
    navigate('/resident');
  };

  const handleHomeClick = () => {
    navigate('/dashboard');
  };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms(prev => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const filteredRows = React.useMemo(() => {
    return rows

      .filter(row => {
        return Object.entries(searchTerms).every(([columnId, term]) => {
          if (!term) return true;
          const value = row[columnId];
          if (typeof value === 'string') {
            return value.toLowerCase().includes(term.toLowerCase());
          } else if (typeof value === 'number') {
            return value.toString().includes(term);
          }
          return true;
        });
      });
  }, [searchTerms, rows]);


  const handleRowDoubleClick = (ResidentDtlId) => {
    navigate('/resident', { state: { ResidentDtlId, mode: 'view' } });
  };

  const handleLocationclick = () => {
    navigate('/masters/arap')
  };

  const getJobTitle = async () => {
    try {
      const response = await axios.post(`MstDesi/getMstDesidrp`)
      if (response.data && response.data.Data) {
        setJobTitle(response.data.Data)
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
    }
  };

  const getRelation = async () => {
    try {
      const response = await axios.post(`MstRelation/getMstRelationdrp`)
      if (response.data && response.data.Data) {
        setRelation(response.data.Data)
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
    }
  };

  const getParty = async () => {
    try {
      const response = await axios.post(`PartyMst/getPartyMstdrp`, {
        PartyCat: "CP"
      });
      if (response.data && response.data.Data) {
        setPartyCat(response.data.Data)
      }
    } catch (err) {
      console.error('Error fetching corporate:', err);
    }
  }

  const GetSourceName = async () => {
    try {
      const response = await axios.post(`MstSource/getMstSourcedrp`)
      if (response.data && response.data.Data) {
        setSource(response.data.Data)
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
    }
  }

  const GetDocTypeName = async () => {
    try {
      const response = await axios.post(`MstSource/getDocumentTypedrp`)
      if (response.data && response.data.Data) {
        setDocTypeName(response.data.Data)
      }
    } catch (err) {
      console.error('Error fetching DocTypeName:', err);
    }
  }

  const GetCourceName = async () => {
    try {
      const response = await axios.post(`MstCourse/getMstCoursedrp`);
      if (response.data && response.data.Data) {
        setCourse(response.data.Data);
      }
    } catch (err) {
      toast.error('Error fetching courses:', err);
    }
  }

  const GetInstituteeName = async () => {
    try {
      const res = await axios.post(`MstInstitute/getMstInstitutedrp`)
      if (res.data && res.data.Data) {
        setInstitutions(res.data.Data)
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
    }
  }

  const GetSemesterName = async () => {
    try {
      const res = await axios.post(`MstSemester/getMstSemesterdrp`)

      if (res.data && res.data.Data) {
        setSemester(res.data.Data)
      }
    } catch (err) {
      console.error('Error fetching courses:', err);
    }
  }

  useEffect(() => {
    GetSourceName()
    GetSemesterName()
    GetInstituteeName()
    GetCourceName()
    GetDocTypeName()
    getJobTitle()
    getParty()
    getRelation()
  }, [])

  const navigate = useNavigate()

  const handleInputChange = (event, field) => {
    const { name, value } = event.target;

    setFormData(prevData => ({
      ...prevData,
      [name]: value,
      mstResidentDtlEntities: [{
        ...prevData.mstResidentDtlEntities[0],
        [name]: value
      }]
    }));

    if (field === 'Mobile') {
      setFormData({
        ...formData,
        [field]: value,
      });
    } else if (field === 'mstResidentDtlEntities[0].Mobile') {

      const updatedEntities = [...formData.mstResidentDtlEntities];
      updatedEntities[0] = { ...updatedEntities[0], Mobile: value };

      setFormData({
        ...formData,
        mstResidentDtlEntities: updatedEntities,
      });
    }
    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: undefined
    }));
  };

  const validateStep = (step) => {
    let stepValid = true;
    let newErrors = {};

    if (step === 0) {
      try {
        formSchema.parse(formData);
      } catch (error) {
        if (error instanceof z.ZodError) {
          error.errors.forEach(err => {
            newErrors[err.path[0]] = err.message;
          });
          stepValid = false;
        }
      }
    }

    setErrors(newErrors);
    return stepValid;
  };

  const handleRadioChange = (field, value) => {

    const updatedFormData = { ...formData, [field]: value };

    if (field === 'BillType' && value === 'C') {
      updatedFormData.Profession = 'C';
    }

    if (field === 'Profession' && value === 'S') {
      updatedFormData.BillType = 'I';
    }

    setFormData(updatedFormData);
  };

  const handleNextdata = async () => {
    if (residentId) {
      await fetchResidentData(residentId, "N");
    }
  }

  const handleBackdata = async () => {
    if (residentId && residentId > 1) {
      await fetchResidentData(residentId, "P");
    }
  }

  const generateSerialId = () => {
    setLastId((prevId) => prevId + 1);
    return lastId + 1;
  };

  const handleAddRow = () => {
    const { RelationTitle, RelativeName, ImgName, RelationId, Age, Mobile, Email, ImgPath, Occupation, Address, CountryId } = formData.mstResidentDtlEntities[0];

    const currentRelativeName = RelativeName;
    const currentRelationId = RelationId;
    const currentImgName = ImgName;
    const missingFields = [];
    if (!RelationTitle) missingFields.push('Title');
    if (!currentRelativeName) missingFields.push('Relative Name');
    if (!currentRelationId) missingFields.push('Relation');

    if (missingFields.length > 0) {
      toast.error(`${missingFields.join(', ')} ${missingFields.length === 1 ? 'is' : 'are'} required.`);
      return;
    }

    const isEditing = selectedRowForEdit !== null;
    const existingRowId = formData.mstResidentDtlEntities[0]?.ResidentDtlId;

    if (!isEditing) {
      const isDuplicateRelativeName = rows.some(
        (existingRow) =>
          existingRow.RelativeName?.toLowerCase() === currentRelativeName?.toLowerCase() &&
          existingRow.DBFLAG !== 'D'
      );

      if (isDuplicateRelativeName) {
        toast.error('Record already exists');
        return;
      }
    }

    const isRelationSelected = Relation.find(item => item.Id == currentRelationId);
    const RelationName = isRelationSelected ? isRelationSelected.Name : '';

    if (isEditing) {
      const updatedRows = rows.map((row) => {
        if (row.ResidentDtlId === existingRowId) {
          return {
            ...row,
            RelationTitle,
            RelativeName: currentRelativeName,
            RelationId: currentRelationId,
            RelationName,
            Age,
            Mobile,
            Email,
            ImgPath,
            ImgName: currentImgName,
            Address,
            Occupation,
            CountryId,
            DBFLAG: row.DBFLAG === 'A' ? 'A' : 'U'
          };
        }
        return row;
      });

      setRows(updatedRows);
      setSelectedRowForEdit(null);

      toast.success('Record updated successfully');
    } else {

      const newResidentDtlId = Date.now();

      const newRow = {
        DBFLAG: 'A',
        ResidentDtlId: newResidentDtlId,
        ResidentId: residentId !== -1 ? residentId : null,
        RelationTitle,
        RelativeName: currentRelativeName,
        RelationId: currentRelationId,
        RelationName,
        Age,
        Mobile,
        Email,
        ImgPath,
        ImgName: currentImgName,
        Address,
        Occupation,
        CountryId,
      };

      setRows(prevRows => [...prevRows, newRow]);
      toast.success('Record added successfully');
    }

    setFormData({
      ...formData,
      mstResidentDtlEntities: [{
        DBFLAG: '',
        RelationTitle: '',
        RelativeName: '',
        RelationId: '',
        Age: '',
        Mobile: '',
        Email: '',
        ImgPath: '',
        ImgName: '',
        Address: '',
        Occupation: '',
        ResidentDtlId: '',
        ResidentId: '',
        CountryId: ''
      }]
    });
  };

  const handleFamilyDelete = (rowToDelete) => {
    setRows((prevRows) => {
      if (rowToDelete.DBFLAG === 'A' && !rowToDelete.ResidentDtlId.toString().includes('-')) {
        return prevRows.filter(row => row.ResidentDtlId !== rowToDelete.ResidentDtlId);
      } else {
        return prevRows.map((row) =>
          row.ResidentDtlId === rowToDelete.ResidentDtlId
            ? { ...row, DBFLAG: 'D' }
            : row
        );
      }
    });

    toast.info('Record deleted');
  };

  const visibleRows = rows.filter((row) => row.DBFLAG !== 'D');

  const handleNext = () => {
    const validateCurrentStep = (step) => {
      let isValid = true;
      const newErrors = {};

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const mobileRegex = /^\d{10}$/;
      const pincodeRegex = /^\d{3}$/;

      if (step === 0) {
        let emptyFieldCount = 0;
        if (!formData.FirstName) {
          newErrors.FirstName = "First Name is required";
          emptyFieldCount++;
          isValid = false;
        }
        if (!formData.Mobile) {
          newErrors.Mobile = "Mobile Number is required";
          emptyFieldCount++;
          isValid = false;
        } else if (!mobileRegex.test(formData.Mobile)) {
          newErrors.Mobile = "Mobile number must be 10 digits";
          isValid = false;
        }

        // Source
        if (!formData.SourceId) {
          newErrors.Source = "Source is required";
          emptyFieldCount++;
          isValid = false;
        }

        if (!formData.Email) {
          newErrors.Email = "Email is required";
          emptyFieldCount++;
          isValid = false;
        } else if (!emailRegex.test(formData.Email)) {
          newErrors.Email = "Email must be a valid address";
          isValid = false;
        }
        if (!formData.Pincode) {
          newErrors.Pincode = "Pincode is required";
          emptyFieldCount++;
          isValid = false;
        }
        //  else if (!pincodeRegex.test(formData.Pincode)) {
        //   newErrors.Pincode = "Pincode must be a 6-digit number";
        //   isValid = false;
        // }
        if (!formData.Name) {
          newErrors.Area = "Area is required";
          emptyFieldCount++;
          isValid = false;
        }

        if (emptyFieldCount === 6) {
          toast.error("Please fill all mandatory fields.");
        } else {
          const firstErrorKey = Object.keys(newErrors)[0];
          if (firstErrorKey) {
            toast.error(newErrors[firstErrorKey]);
          }
        }
      }

      setErrors(newErrors);
      return isValid;
    };

    if (!validateCurrentStep(activeStep)) {
      return;
    }

    if (activeStep === steps.length - 1) {
      handleSubmit();
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleCancelEdit = (row) => {
    setSelectedRowForEdit(null);
    setFormData({
      ...formData,
      mstResidentDtlEntities: [{
        RelationTitle: '',
        RelativeName: '',
        RelationId: '',
        Age: '',
        Mobile: '',
        Email: '',
        ImgPath: '',
        ImgName: '',
        Address: '',
        Occupation: '',
        CountryId: ''
      }]
    });
  };

  const handleFamilyEdit = (row) => {
    console.log('row fro edit', row)
    setSelectedRowForEdit(row);
    const relationItem = Relation.find(item => item.Id === row.RelationId);
    const countryIdStr = row.CountryId ? String(row.CountryId) : (conFlag[0]?.CountryId || '');
    setFormData({
      ...formData,
      mstResidentDtlEntities: [{
        DBFLAG: row.DBFLAG,
        RelationTitle: row.RelationTitle || '',
        RelativeName: row.RelativeName || '',
        RelationId: row.RelationId || (relationItem ? relationItem.Id : ''),
        Age: row.Age || '',
        Address: row.Address || '',
        Occupation: row.Occupation || '',
        Mobile: row.Mobile || '',
        ImgPath: row.ImgPath || '',
        ImgName: row.ImgName || '',
        Email: row.Email || '',
        CountryId: countryIdStr || '',
        ResidentDtlId: row.ResidentDtlId,
        ResidentId: row.ResidentId,
      }],
    });
  };

  // const handleSaveEdit = (row) => {
  //   const updatedRows = rows.map((row) =>
  //     row.ResidentDtlId === formData.mstResidentDtlEntities[0].ResidentDtlId
  //       ? { ...row, ...formData.mstResidentDtlEntities[0], DBFLAG: 'U' }
  //       : row
  //   );
  //   setRows(updatedRows);

  //   setFormData({
  //     ...formData,
  //     mstResidentDtlEntities: [{
  //       DBFLAG: '',
  //       RelationTitle: '',
  //       RelativeName: '',
  //       RelationId: '',
  //       Age: '',
  //       Address: '',
  //       Occupation: '',
  //       Mobile: '',
  //       Email: '',
  //       ImgPath: '',
  //       ResidentDtlId: '',
  //       ResidentId: '',
  //     }],
  //   });
  //   setSelectedRowForEdit(null);
  // };

  const handleSaveEdit = () => {
    const updatedRow = formData.mstResidentDtlEntities[0];

    if (!updatedRow.RelativeName || !updatedRow.RelationId) {
      toast.error('Please fill all required fields');
      return;
    }

    const isRelationSelected = Relation.find(item => item.Id == updatedRow.RelationId);
    const RelationName = isRelationSelected ? isRelationSelected.Name : '';

    setRows(prevRows =>
      prevRows.map(row =>
        row.ResidentDtlId === updatedRow.ResidentDtlId
          ? {
            ...row,
            ...updatedRow,
            RelationName,
            ImgName: updatedRow.ImgName || row.ImgName,
            CountryId: updatedRow.CountryId || row.CountryId,
            DBFLAG: row.DBFLAG === 'A' ? 'A' : 'U'
          }
          : row
      )
    );

    setFormData({
      ...formData,
      mstResidentDtlEntities: [{
        DBFLAG: '',
        RelationTitle: '',
        RelativeName: '',
        RelationId: '',
        Age: '',
        Mobile: '',
        Email: '',
        ImgPath: '',
        Address: '',
        Occupation: '',
        ResidentDtlId: '',
        ResidentId: '',
        CountryId: ''
      }]
    });

    setSelectedRowForEdit(null);
    toast.success('Record updated successfully');
  };

  const handleEditModalClose = () => {
    setSelectedRowForEdit(null);
  };

  const docTypeMappings = {
    '1': 'Aadhar Card',
    '2': 'PAN Card',
    '3': 'Passport',
    '4': 'Driving License',
    '5': 'Voter ID',
    '6': 'Bank Statement',
    '7': 'Other'
  };

  const getDocTypeNameFromFileName = (fileName, docTypeId) => {

    const docTypeName = docTypeMappings[docTypeId] || 'Unknown Document';

    const lowerFileName = fileName.toLowerCase();

    if (lowerFileName.includes('id')) {
      return 'ID';
    } else if (lowerFileName.includes('photo') || lowerFileName.includes('image')) {
      return 'Photo';
    } else if (lowerFileName.includes('address')) {
      return 'Address';
    } else if (lowerFileName.endsWith('.pdf')) {
      return 'PDF';
    } else if (lowerFileName.endsWith('.docx') || lowerFileName.endsWith('.doc')) {
      return 'Word Document';
    } else if (lowerFileName.endsWith('.jpg') || lowerFileName.endsWith('.jpeg') || lowerFileName.endsWith('.png')) {
      return 'Image';
    }

    return docTypeName;
  };

  const handleFileUpload = (event) => {
    const files = event.target.files;

    const docNo = parseInt(formData.DocNo, 10) || 0;
    const docExpDt = formData.DocExpDt;

    const newDocuments = Array.from(files).map((file) => {
      const readFileAsBase64 = new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

      return readFileAsBase64.then(base64String => {
        const docData = {
          DBFLAG: 'A',
          MstResidentDocId: '',
          ResidentId: residentId !== -1 ? parseInt(residentId) : 0,
          DocTypeId: selectedDocType.Id,
          DocTypeName: selectedDocType.Name,
          Remark: '',
          ImgName: file.name,
          ImgPath: base64String,
          DocNo: docNo,
          DocExpDt: docExpDt,
        };
        return docData;
      });
    });

    Promise.all(newDocuments).then((documents) => {
      setFormData((prevFormData) => ({
        ...prevFormData,
        mstResidentDocEntities: [
          ...(prevFormData.mstResidentDocEntities || []),
          ...documents,
        ] || prevFormData.Documents || [],
        Documents: [
          ...(prevFormData.Documents || []),
          ...documents,
        ] || prevFormData.mstResidentDocEntities || [],
      }));
      event.target.value = '';

      setFormData((prevFormData) => ({
        ...prevFormData,
        DocNo: '',
        DocExpDt: ''
      }));
    });
  };

  const handleSubmit = async () => {
    const payload = {
      DBFLAG: residentId === -1 ? 'A' : 'U',
      ResidentId: residentId !== -1 ? parseInt(residentId) : 0,
      FirstName: formData.FirstName,
      MidName: formData.MidName || "",
      LastName: formData.LastName,
      SourceId: parseInt(formData.SourceId) || '',
      SourceName: formData.SourceName,
      ResidentType: formData.ResidentType,
      RefName: formData.RefName,
      Gender: formData.Gender,
      Dob: formData.Dob ? moment(formData.Dob, 'DD/MM/YYYY').format('YYYY-MM-DD') : '' || '1900-01-01',
      Mobile: formData.Mobile,
      Email: formData.Email,
      AadharNo: formData.AadharNo || '',
      PanNo: formData.PanNo || '',
      PinId: parseInt(formData.PinId) || '',
      PermanentAddr: formData.PermanentAddr || '',
      CurrentAddr: formData.CurrentAddr || '',
      Photo: formData.Photo || "",
      AltMob: formData.AltMob || '',
      EmgMob: formData.EmgMob || '',
      BillType: formData.BillType,
      AccountNo: formData.AccountNo,
      BankName: formData.BankName,
      BeneficiaryNm: formData.BeneficiaryNm || '',
      IFSCCode: formData.IFSCCode,
      Profession: formData.Profession,
      BillToPartyId: parseInt(formData.BillToPartyId) || 1,
      InstituteID: parseInt(formData.InstituteID) || 1,
      CourseId: parseInt(formData.CourseId) || 1,
      JobTitle: parseInt(formData.JobTitle) || 1,
      LastHostle: formData.LastHostle || '',
      WorkEmail: formData.WorkEmail || '',
      WorkPhone: formData.WorkPhone || '',
      SemesterId: parseInt(formData.SemesterId) || 1,
      Status: formData.Status || '1',
      Remark: formData.Remark || '',
      // CreatedBy: "1",
      mstResidentDtlEntities: rows.map((row) => {
        const isNewRow = row.DBFLAG === 'A';

        if (row.DBFLAG === "D") {
          return {
            ...row,
            DBFLAG: "D",
            ResidentDtlId: row.ResidentDtlId || 0,
            ResidentId: row.ResidentId || 0,
            ImgPath: row.ImgPath || '',
            ImgName: row.ImgName || '',
            RelationTitle: row.RelationTitle || '',
            RelativeName: row.RelativeName || '',
            RelationId: parseInt(row.RelationId) || 1,
            Mobile: row.Mobile || '',
            Address: row.Address || '',
            Occupation: row.Occupation || '',
            Email: row.Email || '',
            Age: row.Age || '',
            CountryId: row.CountryId || ''
          };
        }

        return {
          DBFLAG: isNewRow ? 'A' : 'U',
          ResidentId: residentId ? parseInt(residentId) : row.ResidentId || 0,
          ResidentDtlId: row.ResidentDtlId || generateSerialId(),
          ImgPath: row.ImgPath || '',
          ImgName: row.ImgName || '',
          RelationTitle: row.RelationTitle || '',
          RelativeName: row.RelativeName || '',
          RelationId: parseInt(row.RelationId) || 1,
          Mobile: row.Mobile || '',
          Address: row.Address || '',
          Occupation: row.Occupation || '',
          Email: row.Email || '',
          Age: row.Age || '',
          CountryId: row.CountryId || ''
        };
      }),
      mstResidentDocEntities: formData.Documents?.map((doc) => {
        const isNewDoc = doc.DBFLAG === 'A';
        let imgPathBase64 = doc.ImgPath || '';

        return {
          DBFLAG: isNewDoc ? 'A' : 'U',
          MstResidentDocId: doc.MstResidentDocId || generateSerialId(),
          ResidentId: residentId !== -1 ? parseInt(residentId) : 0,
          DocTypeId: doc.DocTypeId || '',
          Remark: doc.Remark || '',
          DocTypeName: doc.DocTypeName || '',
          ImgName: doc.ImgName || '',
          ImgPath: imgPathBase64 || '',
          DocNo: doc.DocNo || '',
          DocExpDt: doc.DocExpDt ? moment(doc.DocExpDt, 'DD/MM/YYYY').format('YYYY-MM-DD') : ''
        };
      }) || [],

    };

    setDataForPrint(payload);
    let jsonData = JSON.stringify(payload);

    jsonData = jsonData.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    jsonData = '"' + jsonData + '"';

    try {
      const response = await axios.post("ResidentMst/manageresident", jsonData);
      if (response.data.Status === 1) {
        toast.error(response.data.Message)
        return
      }

      if (response.data.Status === 0) {
        if (mode === "add") {
          clearAll();
          await fetchResidentData(1, "L");
          payload.CreatedBy = parseInt(UserId, 10);
        } else {
          payload.UpdatedBy = parseInt(UserId, 10);
        }
      }
      toast.success(response.data.Message);
      setActiveStep(0);
      setMode("view");
      setIsFormDisabled(true);
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handleDeleteDoc = (index) => {
    const updatedDocs = [...formData.mstResidentDocEntities];
    updatedDocs[index].ImgPath = '';
    setFormData(prev => ({
      ...prev,
      mstResidentDocEntities: updatedDocs
    }));
  };

  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);
    setResidentId(-1);
    setRows([]);
    clearAll();
    setActiveStep(0);
    setErrors({});
    setPhoto('');
  };

  const clearAll = () => {
    setFormData({
      DBFLAG: '',
      FirstName: '',
      MidName: '',
      LastName: '',
      Dob: moment().format('DD/MM/YYYY'),
      Mobile: '',
      Name: "",
      ResidentType: 'I',
      Gender: 'Female',
      BillType: 'I',
      Profession: 'S',
      Email: '',
      SourceId: '',
      SourceName: '',
      RefName: '',
      AadharNo: '',
      PanNo: '',
      Pincode: '',
      AccountNo: '',
      BankName: '',
      BeneficiaryNm: '',
      IFSCCode: '',
      PinId: '',
      PermanentAddr: '',
      CurrentAddr: '',
      Photo: '',
      AltMob: '',
      EmgMob: '',
      CityName: '',
      StateName: '',
      CountryName: '',
      BillToPartyId: '',
      InstituteID: '',
      CourseId: '',
      JobTitle: '',
      LastHostle: '',
      WorkEmail: '',
      WorkPhone: '',
      SemesterId: '',
      Status: '1',
      Remark: '',
      CreatedBy: '1',
      mstResidentDtlEntities: [{
        DBFLAG: "",
        ResidentDtlId: "",
        ResidentId: "",
        ImgPath: "",
        ImgName: "",
        RelationTitle: "",
        RelativeName: "",
        RelationId: "",
        Mobile: "",
        Email: "",
        Address: "",
        Occupation: "",
        Age: "",
        CountryId: conFlag[0]?.CountryId || ''
      }],
      mstResidentDocEntities: [{
        DBFLAG: "",
        MstResidentDocId: "",
        ResidentId: "",
        DocTypeId: "",
        Remark: "",
        DocTypeName: "",
        ImgName: "",
        ImgPath: "",
        DocNo: "",
        DocExpDt: ""
      }],
    });
  }

  const openNewTab = () => {
    window.open("/pincode");
  };

  const handleEdit = () => {
    setMode('edit')
    setIsFormDisabled(false);
  };

  const handleSave = () => {
    setMode('view');
  };

  const familyInfoHandler = () => {
    setOpenConfirmDialog(true);
  };

  const closeConfirmation = () => {
    setOpenConfirmDialog(false);
  };

  const handleCancel = async () => {
    IsFromTransaction && navigate(`/booking`);

    if (mode === 'add') {
      try {
        await fetchResidentData(1, "L");
        setMode('view');
        setIsFormDisabled(true);
      } catch (error) {
        toast.error('Error occurred while cancelling. Please try again.');
      }
    } else if (mode === 'edit') {
      if (residentId) {
        await fetchResidentData(residentId);
      }
      setMode('view');
      setIsFormDisabled(true);
    }
  };

  const handleDelete = () => {
    setIsConfirmDialogOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await fetchResidentData(residentId, "D");
      await fetchResidentData(residentId, "N");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error deleting . Please try again.');
    }
    setIsConfirmDialogOpen(false);
  };

  const handleExit = () => {
    if (IsFromTransaction) {
      navigate(`/booking?MobileNo=${formData.Mobile}`, { replace: false });
    } else {
      navigate(-1);
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };

      readFileAsBase64(file)
        .then(base64String => {
          setFormData(prevData => ({
            ...prevData,
            Photo: base64String
          }));
        })
        .catch(err => {
          console.error('Error reading file:', err);
          toast.error('Error reading file. Please try again.');
        });
    }
  };

  const handleImageSelection = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };

      readFileAsBase64(file)
        .then(base64String => {
          setFormData(prevData => ({
            ...prevData,
            mstResidentDtlEntities: [{ ...prevData.mstResidentDtlEntities[0], ImgPath: base64String, ImgName: file.name }]
          }));
        })
        .catch(err => {
          toast.error('Error reading file. Please try again.');
        });
    }
  };

  useEffect(() => {
    if (formData.Pincode && formData.Pincode.trim().length >= 3 && /^\d+$/.test(formData.Pincode)) {
      (async () => {
        const result = await getAreaByPin(formData.Pincode);
        if (result && Array.isArray(result)) {
          setArea(result);
          if (result.length > 0 && result[0]?.CountryId) {
            setSelectedAreaCountryId(String(result[0].CountryId));
            setFormData(prevData => ({
              ...prevData,
              CountryId: String(result[0].CountryId)
            }));
          }
        }
      })();
    } else {
      setArea([]);

      setFormData((prevData) => ({
        ...prevData,
        CityName: '',
        StateName: '',
        CountryName: '',
        PinId: '',
        CityId: '',
        Name: ''
      }));
    }
  }, [formData.Pincode]);

  useEffect(() => {
    const fetchPlaces = async (Pincode, areaName) => {
      try {
        const { data } = await axios.post(
          `pincodeMst/getdrppincodeAreawise_datafill`,
          {
            PinCode: parseInt(Pincode),
            AreaName: areaName,
          }
        );
        if (data.Status === 0 && data.responseStatusCode === 1) {
          setSites(data.Data);
          const { CityName, StateName, CountryName, PinId, CityId, CountryId } =
            data.Data[0];
          if (CountryId) {
            setSelectedAreaCountryId(String(CountryId));
          }
          setFormData((prevData) => ({
            ...prevData,
            CityName,
            StateName,
            CountryName,
            PinId,
            CityId,
          }));
        }
        else {
          toast.error('Failed to fetch PincodeArea');
        }
      } catch (error) {
        toast.error("Error fetching PincodeArea. Please try again.");
      }
    };

    // if (isValidPinCode(formData.Pincode) && formData.Name) {
    //   fetchPlaces(formData.Pincode.trim(), formData.Name);
    // }
    if (formData.Pincode && formData.Pincode.trim().length >= 3 && /^\d+$/.test(formData.Pincode) && formData.Name) {
      fetchPlaces(formData.Pincode.trim(), formData.Name);
    }
  }, [formData.Pincode, formData.Name]);

  const debounceTimer = useRef(null);

  useEffect(() => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    if (formData.Pincode && formData.Pincode.trim().length >= 3 && /^\d+$/.test(formData.Pincode)) {
      debounceTimer.current = setTimeout(async () => {
        const result = await getAreaByPin(formData.Pincode);
        if (result && Array.isArray(result)) {
          setArea(result);
        } else {
          setArea([]);
          setFormData((prevData) => ({
            ...prevData,
            CityName: '',
            StateName: '',
            CountryName: '',
            PinId: '',
            CityId: '',
            Name: ''
          }));
        }
      }, 500);
    } else {
      setArea([]);
      if (!formData.Pincode || formData.Pincode.trim().length === 0) {
        setFormData((prevData) => ({
          ...prevData,
          CityName: '',
          StateName: '',
          CountryName: '',
          PinId: '',
          CityId: '',
          Name: ''
        }));
      }
    }

    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, [formData.Pincode]);

  const formatDate = (date) => {
    if (date) {
      return moment(date, 'DD/MM/YYYY').format('DD-MM-YYYY');
    }
    return '';
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setFormData((prevState) => ({ ...prevState, Dob: formatDate(date) }));
    setShowCalendar(false);
  };

  const handleDate = (date) => {
    setSelectedDate(date);
    setFormData((prevState) => ({ ...prevState, DocExpDt: formatDate(date) }));
    setShowCalendar(false);
  };

  function replaceImgPath(imgPath) {
    return imgPath.replace('http:/', 'http://');
  }

  const renderStepContent = (step) => {
    return (
      <Box sx={{ height: '350px', overflowY: 'scroll', padding: '16px' }}>
        {(() => {
          switch (step) {
            case 0:
              return (
                <Grid container spacing={2}>
                  <Grid container spacing={1}>
                    <Grid item lg={8} md={8} xs={12}>
                      <Box display="flex" flexDirection="column" gap={1}>
                        <Grid item lg={12} md={12} xs={12}>
                          <Box display="flex" flexDirection="column" gap={2}>
                            <Grid container spacing={1}>
                              <Grid item xs={12} md={3}>
                                {/* <TextField
                                  fullWidth
                                  label={
                                    <span>
                                      Mobile No<span style={{ color: "red" }}>*</span>
                                    </span>
                                  }
                                  name="Mobile"
                                  value={formData.Mobile}
                                  onChange={(e) => handleInputChange(e, 'Mobile')}
                                  variant="filled"
                                  disabled={isFormDisabled}
                                  className="custom-textfield"
                                /> */}
                                <FormControl variant="outlined" fullWidth>
                                  <OutlinedInput
                                    id="personal-mobile-with-country"
                                    startAdornment={
                                      <InputAdornment position="start">
                                        <FormControl variant="filled" size="small" fullWidth>
                                          <Select
                                            value={selectedAreaCountryId || formData.CountryId || (conFlag?.[0]?.CountryId?.toString() || '')}
                                            onChange={(e) => {
                                              const selectedCountry = conFlag?.find(c => String(c.CountryId) === e.target.value);
                                              setFormData({
                                                ...formData,
                                                CountryId: e.target.value,
                                                CountryCode: selectedCountry?.CountryCode || ''
                                              });
                                              setSelectedAreaCountryId(e.target.value);
                                            }}
                                            disabled={isFormDisabled || true}
                                            sx={{
                                              minWidth: 40,
                                              backgroundColor: 'white',
                                              borderRadius: 1,
                                              '& .MuiSelect-select': {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '1px',
                                                backgroundColor: 'white',
                                                padding: '2px 0px',
                                                fontSize: 14,
                                              },
                                              '&.Mui-disabled': {
                                                backgroundColor: 'white',
                                                color: 'black',
                                              },
                                              '& .MuiMenu-paper': {
                                                maxHeight: 200,
                                              },
                                              '&::before': {
                                                borderBottom: 'none !important',
                                              },
                                              '&::after': {
                                                borderBottom: 'none !important',
                                              },
                                              '&:hover::before': {
                                                borderBottom: 'none !important',
                                              },
                                              '&.Mui-focused::before': {
                                                borderBottom: 'none !important',
                                              },
                                              '&.Mui-focused::after': {
                                                borderBottom: 'none !important',
                                              },
                                              '& .MuiOutlinedInput-notchedOutline': {
                                                border: 'none',
                                              },
                                              '&.MuiInputBase-root': {
                                                borderBottom: 'none',
                                              },
                                              '&.Mui-focused': {
                                                borderBottom: 'none',
                                              },
                                            }}
                                          >
                                            {conFlag?.map((country, index) => (
                                              <MenuItem key={index} value={String(country.CountryId)} className='menu_item'>
                                                <img
                                                  src={country.CountryIcon}
                                                  alt={country.CountryName}
                                                  style={{ width: 15, height: 15, marginRight: 1 }}
                                                />
                                                {country.CountryCode}

                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                      </InputAdornment>
                                    }
                                    placeholder="Enter Mobile Number"
                                    name="Mobile"
                                    value={formData.Mobile}
                                    onChange={(e) => handleInputChange(e, 'Mobile')}
                                    disabled={isFormDisabled}
                                    sx={{
                                      height: 40,
                                      fontSize: 16,
                                    }}
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} md={3} className='form_field'>
                                <FormControl variant="filled" fullWidth className="custom-textfield">
                                  <InputLabel id="SourceId-select-label">Source<span style={{ color: "red" }}>*</span></InputLabel>
                                  <Select
                                    labelId="SourceId-select-label"
                                    id="SourceId-select"
                                    name="SourceId"
                                    value={formData.SourceId}
                                    onChange={handleInputChange}
                                    className="custom-textfield"
                                    disabled={isFormDisabled}
                                  >
                                    {source.map((item) => (
                                      <MenuItem key={item.Id} value={item.Id}>{item.Name}</MenuItem>

                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} md={3}>
                                <TextField
                                  fullWidth
                                  label="Source Name"
                                  name="SourceName"
                                  value={formData.SourceName}
                                  onChange={handleInputChange}
                                  variant="filled"
                                  disabled={isFormDisabled}
                                  className="custom-textfield"
                                />
                              </Grid>
                              <Grid item xs={12} md={3}>
                                <TextField
                                  fullWidth
                                  label="Referred By"
                                  name="RefName"
                                  value={formData.RefName}
                                  onChange={handleInputChange}
                                  variant="filled"
                                  disabled={isFormDisabled}
                                  className="custom-textfield"
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label={
                                <span>
                                  FirstName<span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              name="FirstName"
                              value={formData.FirstName}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                              error={!!errors.firstName}
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Middle Name"
                              name="MidName"
                              value={formData.MidName}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Last Name"
                              name="LastName"
                              value={formData.LastName}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label={
                                <span>
                                  Date of Birth<span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              name="Dob"
                              value={formData.Dob}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                              onClick={() => setShowCalendar(!showCalendar)}
                              size="small"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end" >
                                    <CalendarMonthIcon onClick={() => setShowCalendar(!showCalendar)} style={{ cursor: 'pointer' }} />
                                  </InputAdornment>
                                ),
                              }}
                            />

                            {showCalendar && !isFormDisabled && (
                              <div className="calendar-container"
                                style={{
                                  position: 'absolute',
                                  zIndex: 1000,
                                  width: '280px',
                                  fontSize: '25.4px',
                                  height: '200px',
                                  // maxHeight: '200px',
                                  // overflowY: 'auto',
                                }}
                              >
                                <Calendar
                                  onChange={handleDateChange}
                                  value={selectedDate}
                                />
                              </div>
                            )}
                          </Grid>
                        </Grid>

                        <Grid container spacing={1}>
                          <Grid item xs={12} md={6}>
                            <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: '9px' }}>
                              <Grid item>
                                <FormLabel component="legend">Resident Type</FormLabel>
                              </Grid>

                              <Grid item>
                                <FormControl component="fieldset">
                                  <RadioGroup
                                    aria-label="ResidentType"
                                    name="ResidentType"
                                    value={formData.ResidentType}
                                    onChange={handleInputChange}
                                    row
                                  >
                                    <FormControlLabel
                                      value="I"
                                      control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                                      label="Individual"
                                      className="custom-textfield"
                                      disabled={isFormDisabled}
                                    />
                                    <FormControlLabel
                                      value="C"
                                      control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                                      label="Corporate"
                                      className="custom-textfield"
                                      disabled={isFormDisabled}
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: '9px' }}>
                              <Grid item>
                                <FormLabel component="legend">Gender</FormLabel>
                              </Grid>

                              <Grid item>
                                <FormControl component="fieldset">
                                  <RadioGroup
                                    aria-label="Gender"
                                    name="Gender"
                                    value={formData.Gender}
                                    onChange={handleInputChange}
                                    row
                                  >
                                    <FormControlLabel
                                      value="Male"
                                      control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                                      label="Male"
                                      className="custom-textfield"
                                      disabled={isFormDisabled}
                                    />
                                    <FormControlLabel
                                      value="Female"
                                      control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                                      label="Female"
                                      className="custom-textfield"
                                      disabled={isFormDisabled}
                                    />
                                    <FormControlLabel
                                      value="Others"
                                      control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />}
                                      label="Others"
                                      className="custom-textfield"
                                      disabled={isFormDisabled}
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </Grid>
                            </Grid>

                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                    <Grid item lg={4} md={4} xs={12} display="flex" alignItems="center" justifyContent="center">
                      <Link
                        onClick={familyInfoHandler}
                        sx={{
                          position: 'relative',
                          cursor: "pointer",
                          top: -48,
                          right: 0,
                          bottom: 0,
                          left: -32
                        }}
                        disabled={isFormDisabled}
                      >
                        FamilyInfo
                      </Link>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        gap={2}
                        border="1px solid #ccc"
                        borderRadius={1}
                        width={80}
                        height={110}
                        overflow="hidden"
                        position="relative"
                      >
                        {formData.Photo ? (
                          <img
                            src={formData.Photo}
                            alt="Uploaded Preview"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              marginTop: "4px"
                            }}
                          />
                        ) : (
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            style={{ textAlign: 'center' }}
                          >
                            Image Preview
                          </Typography>
                        )}
                      </Box>
                      <input
                        accept="image/*"
                        style={{ display: 'none' }}
                        id="upload-photo"
                        type="file"
                        onChange={handleImageChange}
                        disabled={isFormDisabled}
                      />
                      <label htmlFor="upload-photo">
                        <Button
                          component="span"
                          style={{ marginTop: '5px' }}
                        >
                          Upload Image
                        </Button>
                      </label>
                    </Grid>
                    <Grid item lg={12} md={12} xs={12}>
                      <Box display="flex" flexDirection="column" gap={2}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={2}>
                            <TextField
                              fullWidth
                              label={<span> mail ID<span style={{ color: "red" }}>*</span> </span>}
                              name="Email"
                              type="email"
                              value={formData.Email}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <TextField
                              fullWidth
                              label="Emergency Mobile"
                              name="EmgMob"
                              value={formData.EmgMob}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <TextField
                              fullWidth
                              label="Alt Mobile"
                              name="AltMob"
                              value={formData.AltMob}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <TextField
                              fullWidth
                              label="Pan No"
                              name="PanNo"
                              value={formData.PanNo}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <TextField
                              fullWidth
                              label="Aadhar No"
                              name="AadharNo"
                              value={formData.AadharNo}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                    <Grid item lg={12} md={12} xs={12}>
                      <Box display="flex" flexDirection="column" gap={2}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={2}>
                            <TextField
                              fullWidth
                              label={
                                <span>
                                  Pincode<span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              name="Pincode"
                              value={formData.Pincode}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                              InputProps={{
                                endAdornment: !isFormDisabled && (
                                  <InputAdornment position="end">
                                    <AddIcon
                                      onClick={openNewTab}
                                      style={{ cursor: "pointer" }}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={2} >
                            <FormControl
                              variant="filled"
                              fullWidth
                              className="custom-textfield"
                            >
                              <InputLabel id="areaName-select-label">
                                Area <span style={{ color: "red" }}>*</span>
                              </InputLabel>
                              <Select
                                labelId="areaName-select-label"
                                id="areaName-select"
                                name="Name"
                                value={formData.Name}
                                onChange={handleInputChange}
                                className="custom-textfield"
                                disabled={isFormDisabled}
                              >
                                {area.length > 0 ? (
                                  area.map((areaItem) => (
                                    <MenuItem
                                      key={areaItem.Id}
                                      value={areaItem.Name}
                                    >
                                      {areaItem.Name}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem value="" disabled>
                                    No areas available
                                  </MenuItem>
                                )}
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <TextField
                              fullWidth
                              label="City"
                              name="CityName"
                              value={formData.CityName}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <TextField
                              fullWidth
                              label="State"
                              name="StateName"
                              value={formData.StateName}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                          <Grid item xs={12} md={2}>
                            <TextField
                              fullWidth
                              label="Country"
                              name="CountryName"
                              value={formData.CountryName}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                            />
                          </Grid>
                        </Grid>
                      </Box>

                    </Grid>
                    <Grid item lg={12} md={12} xs={12}>
                      <Box display="flex" flexDirection="column" gap={2}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={4}>
                            <TextField
                              fullWidth
                              label="Remark (if any) .."
                              name="Remark"
                              value={formData.Remark}
                              onChange={handleInputChange}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                              sx={{
                                '& .MuiInputBase-root': {
                                  height: '80px',
                                  padding: '0px 14px',
                                  display: 'flex',
                                  alignItems: 'flex-start'
                                },
                                '& .MuiInputBase-input': {
                                  resize: 'vertical',
                                  padding: '8px 0',
                                  lineHeight: '1.5'
                                },
                                '& .MuiFilledInput-root': {
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-focused': {
                                    backgroundColor: 'transparent',
                                  },
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Permanent Address"
                              name="PermanentAddr"
                              value={formData.PermanentAddr}
                              onChange={handleInputChange}
                              rows={2}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                              sx={{
                                '& .MuiInputBase-root': {
                                  height: '80px',
                                  padding: '0px 14px',
                                  display: 'flex',
                                  alignItems: 'flex-start',
                                },
                                '& .MuiInputBase-input': {
                                  resize: 'vertical',
                                  padding: '8px 0',
                                  lineHeight: '1.5'
                                },
                                '& .MuiFilledInput-root': {
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-focused': {
                                    backgroundColor: 'transparent',
                                  },
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Correspondence Address"
                              name="CurrentAddr"
                              value={formData.CurrentAddr}
                              onChange={handleInputChange}
                              rows={2}
                              variant="filled"
                              disabled={isFormDisabled}
                              className="custom-textfield"
                              sx={{
                                '& .MuiInputBase-root': {
                                  height: '80px',
                                  padding: '0px 14px',
                                  display: 'flex',
                                  alignItems: 'flex-start'
                                },
                                '& .MuiInputBase-input': {
                                  resize: 'vertical',
                                  padding: '8px 0',
                                  lineHeight: '1.5'
                                },
                                '& .MuiFilledInput-root': {
                                  '&:hover': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&.Mui-focused': {
                                    backgroundColor: 'transparent',
                                  },
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              );
            case 1:
              return (
                <>
                  <Grid container spacing={2}>
                    <Grid container spacing={2}>
                      <Grid item lg={10} md={10} xs={12}>
                        <Box display="flex" flexDirection="column" gap={2}>
                          <Grid item lg={12} md={12} xs={12}>
                            <Box display="flex" flexDirection="column" gap={2}>
                              <Grid container spacing={1}>
                                <Grid item xs={12} md={1.5}>
                                  <FormControl variant="filled" fullWidth className="custom-textfield">
                                    <InputLabel id="RelationTitle-select-label">Title<span style={{ color: "red" }}>*</span></InputLabel>
                                    <Select
                                      labelId="RelationTitle-select-label"
                                      id="RelationTitle"
                                      name="RelationTitle"
                                      value={formData.mstResidentDtlEntities[0].RelationTitle}
                                      onChange={handleInputChange}
                                      disabled={isFormDisabled}
                                      className="custom-textfield"
                                    >
                                      <MenuItem key="mr" value="Mr">Mr.</MenuItem>
                                      <MenuItem key="miss" value="Miss">Miss.</MenuItem>
                                      <MenuItem key="mrs" value="Mrs">Mrs.</MenuItem>
                                      <MenuItem key="ms" value="Ms">Ms.</MenuItem>
                                      <MenuItem key="mx" value="Mx">Mx.</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                  <TextField
                                    fullWidth
                                    label={
                                      <span>
                                        Name<span style={{ color: "red" }}>*</span>
                                      </span>
                                    }
                                    variant="filled"
                                    name='RelativeName'
                                    disabled={isFormDisabled}
                                    value={formData.mstResidentDtlEntities[0].RelativeName}
                                    onChange={handleInputChange}
                                    className="custom-textfield" />
                                </Grid>
                                <Grid item xs={12} md={3} className='form_field'>
                                  <FormControl variant="filled" fullWidth className="custom-textfield">
                                    <InputLabel id="RelationId-select-label">Relation<span style={{ color: "red" }}>*</span></InputLabel>
                                    <Select
                                      labelId="RelationId-select-label"
                                      id="RelationId-select"
                                      name="RelationId"
                                      value={formData.mstResidentDtlEntities[0].RelationId || ""}
                                      onChange={handleInputChange}
                                      className="custom-textfield"
                                      disabled={isFormDisabled}
                                    >
                                      {Relation.map((item) => (
                                        <MenuItem key={item.Id} value={item.Id}>{item.Name}</MenuItem>

                                      ))}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                  <TextField
                                    fullWidth
                                    label="Occupation"
                                    variant="filled"
                                    name="Occupation"
                                    value={formData.mstResidentDtlEntities[0].Occupation}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    className="custom-textfield" />
                                </Grid>
                              </Grid>
                            </Box>
                          </Grid>
                          <Grid container spacing={1}>
                            <Grid item xs={12} md={3}>
                              <FormControl variant="outlined" fullWidth>
                                <OutlinedInput
                                  id="mobile-with-country"
                                  startAdornment={
                                    <InputAdornment position="start" >
                                      <FormControl variant="filled" size="small" fullWidth>
                                        <Select
                                          value={formData.mstResidentDtlEntities[0]?.CountryId ? String(formData.mstResidentDtlEntities[0].CountryId) : (conFlag[0]?.CountryId?.toString() || '2')}
                                          onChange={(e) => {
                                            const updatedEntities = [...formData.mstResidentDtlEntities];
                                            updatedEntities[0] = { ...updatedEntities[0], CountryId: e.target.value };
                                            setFormData({
                                              ...formData,
                                              mstResidentDtlEntities: updatedEntities
                                            });
                                          }}
                                          disabled={isFormDisabled}
                                          sx={{
                                            minWidth: 40,
                                            backgroundColor: 'white',
                                            borderRadius: 1,
                                            '& .MuiSelect-select': {
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: '1px',
                                              backgroundColor: 'white',
                                              padding: '2px 0px',
                                              fontSize: 14,
                                            },

                                            '&.Mui-disabled': {
                                              backgroundColor: 'white',
                                              color: 'black',
                                            },
                                            '& .MuiMenu-paper': {
                                              maxHeight: 200,
                                            },
                                            '&::before': {
                                              borderBottom: 'none !important',
                                            },
                                            '&::after': {
                                              borderBottom: 'none !important',
                                            },
                                            '&:hover::before': {
                                              borderBottom: 'none !important',
                                            },
                                            '&.Mui-focused::before': {
                                              borderBottom: 'none !important',
                                            },
                                            '&.Mui-focused::after': {
                                              borderBottom: 'none !important',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                              border: 'none',
                                            },
                                            '&.MuiInputBase-root': {
                                              borderBottom: 'none',
                                            },
                                            '&.Mui-focused': {
                                              borderBottom: 'none',
                                            },
                                          }}
                                        >
                                          {conFlag.map((country, index) => (
                                            <MenuItem key={index} value={country.CountryId} className='menu_item'>
                                              <img
                                                src={country.CountryIcon}
                                                alt={country.CountryName}
                                                style={{ width: 15, height: 15, marginRight: 2 }}
                                              />
                                              {country.CountryCode}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </InputAdornment>
                                  }
                                  placeholder="Enter Mobile Number"
                                  value={formData.mstResidentDtlEntities[0]?.Mobile || ''}
                                  onChange={(e) => handleInputChange(e, 'mstResidentDtlEntities[0].Mobile')}
                                  disabled={isFormDisabled}
                                  sx={{
                                    height: 40,
                                    fontSize: 16,
                                  }}
                                />
                              </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6.5}>
                              <TextField
                                fullWidth
                                label="Address"
                                name="Address"
                                value={formData.mstResidentDtlEntities[0].Address}
                                onChange={handleInputChange}
                                rows={2}
                                variant="filled"
                                disabled={isFormDisabled}
                                className="custom-textfield"
                                sx={{
                                  '& .MuiInputBase-root': {
                                    height: '80px',
                                    padding: '0px 14px',
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                  },
                                  '& .MuiInputBase-input': {
                                    resize: 'vertical',
                                    padding: '8px 0',
                                    lineHeight: '1.5'
                                  },
                                  '& .MuiFilledInput-root': {
                                    '&:hover': {
                                      backgroundColor: 'transparent',
                                    },
                                    '&.Mui-focused': {
                                      backgroundColor: 'transparent',
                                    },
                                  },
                                }}
                              />
                            </Grid>

                            <Grid item xs={12} md={2.5}>
                              {!selectedRowForEdit ? (
                                <Button
                                  variant="contained"
                                  onClick={handleAddRow}
                                  disabled={isFormDisabled}
                                  sx={{
                                    backgroundColor: "#7c3aed",
                                    color: "white",
                                    "&:hover": {
                                      backgroundColor: "#7c3aed",
                                    },
                                  }}
                                >
                                  Add
                                </Button>
                              ) : (
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                  <Button
                                    variant="contained"
                                    onClick={handleSaveEdit}
                                    disabled={isFormDisabled}
                                    sx={{
                                      backgroundColor: "#7c3aed",
                                      color: "white",
                                      "&:hover": {
                                        backgroundColor: "#7c3aed",
                                      },
                                    }}
                                  >
                                    Update
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    onClick={handleCancelEdit}
                                    disabled={isFormDisabled}
                                    sx={{
                                      borderColor: "#7c3aed",
                                      color: "#7c3aed",
                                      "&:hover": {
                                        borderColor: "#7c3aed",
                                        backgroundColor: "rgba(124, 58, 237, 0.04)",
                                      },
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </Box>
                              )}
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                      <Grid item lg={2} md={2} xs={12}
                        display="flex" alignItems="center" justifyContent="center"
                        sx={{
                          position: 'relative',
                          right: selectedRowForEdit ? 80 : 180,
                          bottom: selectedRowForEdit ? 0 : -3.5,
                          marginTop: selectedRowForEdit ? "20px" : '20px'
                        }}
                      >
                        <Box
                          display="flex"
                          flexDirection="column"
                          alignItems="center"
                          justifyContent="center"
                          gap={2}
                          border="1px solid #ccc"
                          borderRadius={1}
                          width={35}
                          height={50}
                          overflow="hidden"
                          position="relative"
                        >
                          {formData.mstResidentDtlEntities[0].ImgPath ? (
                            <img
                              src={replaceImgPath(formData.mstResidentDtlEntities[0].ImgPath)}
                              alt="Uploaded Preview"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                              }} />
                          ) : (
                            <Typography
                              variant="body2"
                              color="textSecondary"
                              style={{ textAlign: 'center' }}
                            >
                              Image Preview
                            </Typography>
                          )}
                        </Box>
                        <input
                          accept="image/*"
                          style={{ display: 'none' }}
                          id="upload-photo"
                          type="file"
                          disabled={isFormDisabled}
                          onChange={handleImageSelection} />
                        <label htmlFor="upload-photo">
                          <Button
                            // variant="contained"
                            component="span"
                            style={{ marginTop: '5px' }}
                          >
                            Upload Image
                          </Button>
                        </label>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Paper sx={{ width: '100%', overflow: 'hidden', margin: '10px 0px 0px -15px', border: '1px solid lightgray' }}>
                    <TableContainer sx={{ maxHeight: 450 }}>
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                          <TableRow
                            sx={{
                              '& > th': {
                                padding: '2px  10px 2px  10px'
                              }
                            }}
                          >
                            {columns.map((column) => (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                              >
                                <Typography variant="subtitle1" fontWeight="bold">
                                  {column.label}
                                </Typography>
                                <TextField
                                  size="small"
                                  variant="outlined"
                                  placeholder={`Search ${column.label}`}
                                  onChange={(e) => handleSearchChange(column.id, e.target.value)}
                                  sx={{
                                    mt: 1, margin: '0px', '& .MuiOutlinedInput-input': {
                                      padding: '2px 6px',
                                    },
                                  }}

                                />
                              </TableCell>
                            ))}
                            <TableCell ></TableCell>
                            <TableCell >
                              <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                              >
                                Action
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {visibleRows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                              return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.ResidentDtlId}
                                  onDoubleClick={() => handleRowDoubleClick(row.ResidentDtlId)}
                                  style={{ cursor: 'pointer' }}
                                  sx={{
                                    '& > td': {
                                      padding: '2px  14px 2px  19px',
                                    }
                                  }}
                                >
                                  {columns.map((column) => {
                                    const value = row[column.id];
                                    return (
                                      <TableCell key={column.id} align={column.align}>
                                        {value}
                                      </TableCell>
                                    );
                                  })}

                                  <TableCell >
                                    {row.DBFLAG || 'R'}
                                  </TableCell>
                                  <TableCell>
                                    <Box
                                      sx={{ padding: 0, display: 'flex', justifyContent: 'space-between' }}
                                    >
                                      <Button
                                        onClick={() => handleFamilyEdit(row)}
                                        disabled={isFormDisabled}
                                        sx={{
                                          padding: 0,
                                          position: "relative",
                                          right: 35,
                                          '&:hover': { backgroundColor: 'transparent' }
                                        }}
                                      >
                                        <EditIcon />
                                      </Button>
                                      <Button
                                        onClick={() => handleFamilyDelete(row)}
                                        disabled={isFormDisabled}
                                        sx={{
                                          padding: 0,
                                          position: "relative",
                                          right: 70,
                                          '&:hover': { backgroundColor: 'transparent' }
                                        }}
                                      >
                                        <DeleteIcon />
                                      </Button>
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 15, 100]}
                      component="div"
                      count={filteredRows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Paper>
                </>
              );
            case 2:
              return (
                <>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={4}>
                      <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: '9px' }}>
                        <Grid item>
                          <FormLabel component="legend">Billing Type</FormLabel>
                        </Grid>
                        <Grid item>
                          <FormControl component="fieldset">
                            <RadioGroup
                              aria-label="BillType"
                              name="BillType"
                              value={formData.BillType}
                              onChange={(e) => handleRadioChange('BillType', e.target.value)}
                              row
                            >
                              <FormControlLabel
                                value="I"
                                control={<Radio />}
                                disabled={isFormDisabled}
                                label="Individual"
                              />
                              <FormControlLabel
                                value="C"
                                control={<Radio />}
                                disabled={isFormDisabled}
                                label="Corporate"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Grid container alignItems="center" spacing={1} sx={{ paddingLeft: '9px' }}>
                        <Grid item>
                          <FormLabel component="legend">Profession</FormLabel>
                        </Grid>
                        <Grid item>
                          <FormControl component="fieldset">
                            <RadioGroup
                              aria-label="Profession"
                              name="Profession"
                              value={formData.Profession}
                              onChange={(e) => handleRadioChange('Profession', e.target.value)}
                              row
                            >
                              <FormControlLabel
                                value="S"
                                control={<Radio />}
                                disabled={isFormDisabled}
                                label="Student"
                              />
                              <FormControlLabel
                                value="C"
                                control={<Radio />}
                                disabled={isFormDisabled}
                                onChange={(e) => handleRadioChange('Profession', e.target.value)}
                                label="Service"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container gap={1}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={3} className='form_field'>
                        <FormControl variant="filled" fullWidth className="custom-textfield">
                          <InputLabel id="jobTitle-select-label">Job Title<span style={{ color: "red" }}>*</span></InputLabel>
                          <Select
                            labelId="JobTitle-select-label"
                            id="JobTitle-select"
                            name="JobTitle"
                            value={formData.JobTitle}
                            onChange={handleInputChange}
                            className="custom-textfield"
                            disabled={isFormDisabled}
                          >
                            {jobTitle.map((item) => (
                              <MenuItem key={item.Id} value={item.Id}>{item.Name}</MenuItem>

                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={4} className='form_field'>
                        <CustomAutocomplete
                          options={institutions}
                          id="InstituteID-autocomplete"
                          name='InstituteID'
                          label="Institutions"
                          value={institutions.find(InstituteID => InstituteID.Id == formData.InstituteID) || null}
                          onChange={handleInputChange}
                          disabled={isFormDisabled}
                          className="custom-textfield"
                          variant='filled'
                        />
                      </Grid>
                      <Grid item xs={12} md={3} className='form_field'>
                        <CustomAutocomplete
                          options={course}
                          id="CourseId-autocomplete"
                          name='CourseId'
                          label="Course"
                          value={course.find(CourseId => CourseId.Id == formData.CourseId) || null}
                          onChange={handleInputChange}
                          disabled={isFormDisabled || formData.Profession !== 'S'}
                          className="custom-textfield"
                          variant='filled'
                        />
                      </Grid>
                      <Grid item xs={12} md={2} className='form_field'>
                        <FormControl variant="filled" fullWidth className="custom-textfield">
                          <InputLabel id="SemesterId-select-label">Semester</InputLabel>
                          <Select
                            labelId="SemesterId-select-label"
                            id="SemesterId-select"
                            name="SemesterId"
                            value={formData.SemesterId}
                            onChange={handleInputChange}
                            disabled={isFormDisabled || formData.Profession !== 'S'}
                          >
                            {semester.map((sem) => (
                              <MenuItem key={sem.Id} value={sem.Id}>
                                {sem.Name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={3} className='form_field'>
                        <FormControl variant="filled" fullWidth className="custom-textfield">
                          <InputLabel id="BillToPartyId-select-label">Billing Corporate</InputLabel>
                          <Select
                            labelId="BillToPartyId-select-label"
                            id="BillToPartyId-select"
                            name="BillToPartyId"
                            value={formData.BillToPartyId}
                            onChange={handleInputChange}
                            className="custom-textfield"
                            disabled={formData.BillType === "I" && formData.Profession === "S" || formData.BillType === "I" && formData.Profession === "C" || isFormDisabled}
                          >
                            {PartyCat.map((party) => (
                              <MenuItem key={party.Id} value={party.Id}>
                                {party.Name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          id="WorkEmail"
                          name="WorkEmail"
                          label="Work Email"
                          variant="filled"
                          fullWidth
                          className="custom-textfield"
                          value={formData.WorkEmail}
                          disabled={isFormDisabled}
                          onChange={handleInputChange}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          id="WorkPhone"
                          name="WorkPhone"
                          label="Work PhoneNo"
                          variant="filled"
                          fullWidth
                          className="custom-textfield"
                          value={formData.WorkPhone}
                          disabled={isFormDisabled}
                          onChange={handleInputChange}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          id="LastHostle"
                          name="LastHostle"
                          label="Last Hostle"
                          variant="filled"
                          fullWidth
                          className="custom-textfield"
                          value={formData.LastHostle}
                          disabled={isFormDisabled}
                          onChange={handleInputChange}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          id="BankName"
                          name="BankName"
                          label="Bank Name"
                          variant="filled"
                          fullWidth
                          className="custom-textfield"
                          value={formData.BankName}
                          disabled={isFormDisabled}
                          onChange={handleInputChange}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          id="BeneficiaryNm"
                          name="BeneficiaryNm"
                          label="Beneficiary Name"
                          variant="filled"
                          fullWidth
                          className="custom-textfield"
                          value={formData.BeneficiaryNm}
                          disabled={isFormDisabled}
                          onChange={handleInputChange}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          id="IFSCCode"
                          name="IFSCCode"
                          label="IFSC Code"
                          variant="filled"
                          fullWidth
                          className="custom-textfield"
                          value={formData.IFSCCode}
                          disabled={isFormDisabled}
                          onChange={handleInputChange}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          id="AccountNo"
                          name="AccountNo"
                          label="Account No"
                          variant="filled"
                          fullWidth
                          className="custom-textfield"
                          value={formData.AccountNo}
                          disabled={isFormDisabled}
                          onChange={handleInputChange}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              );
            case 3:
              return (
                <Box>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={2} lg={2.5} className="form_field">
                      <FormControl variant="filled" fullWidth className="custom-textfield">
                        <InputLabel id="DocTypeName-select-label">
                          DocTypeName<span style={{ color: 'red' }}>*</span>
                        </InputLabel>
                        <Select
                          labelId="DocTypeName-select-label"
                          id="DocTypeName-select"
                          name="DocTypeName"
                          value={selectedDocType.Id}
                          onChange={(e) => {
                            const selectedItem = docTypeName.find(item => item.Id === e.target.value);
                            setSelectedDocType({ Id: selectedItem.Id, Name: selectedItem.Name });
                          }}
                          className="custom-textfield"
                          disabled={isFormDisabled}
                        >
                          {docTypeName.map((item) => (
                            <MenuItem key={item.Id} value={item.Id}>
                              {item.Name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6} lg={2.5}>
                      <TextField
                        id="DocNo"
                        name="DocNo"
                        label="Document No"
                        variant="filled"
                        fullWidth
                        className="custom-textfield"
                        value={formData.DocNo || ''}
                        disabled={isFormDisabled}
                        onChange={(event) => handleInputChange(event, 'DocNo')}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={2.5}>
                      <TextField
                        fullWidth
                        label="Doc Expire Date"
                        name="DocExpDt"
                        id="DocExpDt"
                        value={formData.DocExpDt}
                        onChange={(event) => handleInputChange(event, 'DocExpDt')}
                        variant="filled"
                        disabled={isFormDisabled}
                        className="custom-textfield"
                        onClick={() => setShowCalendar(!showCalendar)}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <CalendarMonthIcon onClick={() => setShowCalendar(!showCalendar)} style={{ cursor: 'pointer' }} />
                            </InputAdornment>
                          ),
                        }}
                      />

                      {showCalendar && !isFormDisabled && (
                        <div className="calendar-container"
                          style={{
                            position: 'absolute',
                            zIndex: 1000,
                            width: '280px',
                            fontSize: '25.4px',
                            height: '200px',
                          }}
                        >
                          <Calendar
                            onChange={handleDate}
                            value={selectedDate}
                          />
                        </div>
                      )}
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <Input
                        type="file"
                        style={{
                          width: '100%',
                          display: 'flex',
                          marginTop: '10px'
                        }}
                        disabled={isFormDisabled}
                        onChange={handleFileUpload}
                        inputProps={{ multiple: true }}
                      />
                    </Grid>
                  </Grid>

                  {Array.isArray(formData.mstResidentDocEntities) && formData.mstResidentDocEntities.length > 0 ? (
                    <Box sx={{
                      padding: '20px',
                      backgroundColor: '#f0f4f8',
                      borderRadius: '12px',
                      width: '100%',
                      maxWidth: '1200px',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      marginTop: '20px',
                      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
                    }}>
                      <Typography variant="h6" sx={{
                        fontWeight: '600',
                        color: '#2c3e50',
                        marginBottom: '20px',
                        fontSize: '20px',
                        textAlign: 'center',
                      }}>
                        KYC Documents
                      </Typography>

                      <Grid container spacing={2} justifyContent="flex-start">
                        {formData.mstResidentDocEntities.map((doc, index) => (
                          doc.ImgPath ? (
                            <Grid item xs={6} sm={3} md={3} lg={3} key={index}>
                              <Box sx={{
                                position: 'relative', // for the delete button
                                padding: '15px',
                                borderRadius: '10px',
                                backgroundColor: '#ffffff',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease',
                                cursor: 'pointer',
                                overflow: 'hidden',
                                textAlign: 'center',
                                '&:hover': {
                                  transform: 'scale(1.05)',
                                },
                              }}
                                onClick={() => handleImageClick(doc.ImgPath, doc.DocTypeName)}
                              >
                                {/* Delete Icon */}
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation(); // prevent triggering handleImageClick
                                    handleDeleteDoc(index); // your delete function
                                  }}
                                  disabled={isFormDisabled}
                                  sx={{
                                    position: 'absolute',
                                    top: 5,
                                    right: 5,
                                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                  }}
                                >
                                  <DeleteIcon fontSize="small" sx={{ color: 'red' }} />
                                </IconButton>

                                <Typography variant="body1" sx={{
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  color: '#34495e',
                                  marginBottom: '8px',
                                }}>
                                  {doc.DocTypeName}
                                </Typography>

                                <Box
                                  sx={{
                                    width: '100%',
                                    height: '120px',
                                    overflow: 'hidden',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                  }}
                                >
                                  {doc.ImgPath.toLowerCase().endsWith('.pdf') ? (
                                    <img
                                      src="https://t4.ftcdn.net/jpg/04/65/41/29/360_F_465412924_Ir2XnMp0TYJYtpl1IdNSPYt0UNDVMJv3.jpg"
                                      alt="PDF Document"
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                        borderRadius: '8px',
                                        transition: 'transform 0.3s ease',
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src={replaceImgPath(doc.ImgPath)}
                                      alt={doc.DocTypeName}
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                        borderRadius: '8px',
                                        transition: 'transform 0.3s ease',
                                      }}
                                    />
                                  )}
                                </Box>
                              </Box>
                            </Grid>
                          ) : null
                        ))}
                      </Grid>
                    </Box>
                  ) : (
                    <Box sx={{ marginTop: '20px', textAlign: 'center' }}>
                      <Typography variant="body2" color="gray">
                        No KYC documents uploaded yet.
                      </Typography>
                    </Box>
                  )}
                </Box>
              );
            default:
              return null;
          }
        })()}
      </Box >
    );
  };

  const handleStepClick = (step) => {
    if (mode === 'view') {
      setActiveStep(step);
    }
  };

  return (
    <Grid >
      <Box className="form-container">
        <ToastContainer />
        <Grid container spacing={2} className='rasidant_grid'>
          <Grid item xs={12} className='form_title' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px' }}>
            <Grid>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635BFF' }}
                className='three-d-button-previous'
                onClick={handleBackdata}
                disabled={activeStep.length === 0 || mode !== 'view'}
              >
                <KeyboardArrowLeftIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                className='three-d-button-next'
                sx={{ backgroundColor: '#635BFF', margin: '0px 10px' }}
                onClick={handleNextdata}
                disabled={activeStep === steps.length - 1 || mode !== 'view'}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <Typography variant="h5">Resident Master</Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Resident Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} >
            <Stepper activeStep={activeStep} connector={<CustomStepConnector />} >
              {steps.map((label, index) => (
                <Step key={label} onClick={() => handleStepClick(index)} style={{ cursor: mode === 'view' ? 'pointer' : 'default' }}>
                  <CustomStepLabel
                    StepIconComponent={(props) => (
                      <CustomStepIcon ownerState={{ ...props, active: activeStep === index }}>
                        {index + 1}
                      </CustomStepIcon>
                    )}
                  >
                    {label}
                  </CustomStepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>

          <Grid item xs={12}>
            {renderStepContent(activeStep)}
          </Grid>

          <Grid item xs={12} className="form_button">
            <Button
              variant="contained"
              size="small"
              sx={{ mr: 1, backgroundColor: '#635BFF', color: 'white' }}
              onClick={handleBack}
              disabled={activeStep === 0 || mode === 'view'}
            >
              Previous
            </Button>
            <Button
              variant="contained"
              onClick={handleNext}
              sx={{ mr: 1, backgroundColor: '#635BFF', color: 'white' }}
              disabled={mode === "view"}
            >
              {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
            </Button>
            <Button
              variant="contained"
              onClick={handleCancel}
              disabled={mode === "view"}
              sx={{ mr: 1, background: 'linear-gradient(290deg, #125dadff, #e9f2fa)', color: 'black' }}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <Report formData={DataForPrint} jobTitle={jobTitle} institutions={institutions} course={course} semester={semester} PartyCat={PartyCat} contentRef={contentRef} />}
      </div>

      <ConfirmDialog
        open={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        title="Confirm Delete"
        content="Are you sure you want to delete this data?"
        onConfirm={handleConfirmDelete}
      />
      <Grid item xs={6} md={6} sm={6} lg={6} xl={6} className="form_field">
        <Dialog
          open={openConfirmDialog}
          onClose={closeConfirmation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{
            "& .MuiDialog-paper": {
              maxWidth: "100%",
              width: {
                xs: "80%",
                sm: "600px",
                md: "690px",
                lg: "1000px",
                xl: "800px",
              },
              height: {
                xs: "auto",
                sm: "auto",
                md: "auto",
                lg: "auto",
                xl: "auto",
              },
              padding: {
                xs: "10px",
                sm: "15px",
                md: "20px",
                lg: "20px",
                xl: "20px",
              },
              margin: {
                xs: "20px",
                sm: "40px",
                md: "60px",
                lg: "60px",
                xl: "60px",
              },
              backgroundColor: "white",
              borderRadius: "10px",
              border: "1px solid #ccc",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            },
          }}
        >
          <DialogTitle id="alert-dialog-title">
            <IconButton edge="end" color="inherit" onClick={closeConfirmation}
              sx={{
                position: "relative",
                cursor: "pointer",
                top: -24,
                right: 0,
                bottom: 0,
                left: 900
              }}
            >
              <CloseIcon />
            </IconButton>
            <Grid>
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  backgroundColor: "transparent",
                  overflow: "hidden",
                  maxHeight: {
                    xs: "50vh",
                    sm: "55vh",
                    md: "60vh",
                    lg: "65vh",
                    xl: "70vh",
                  },
                  height: {
                    xs: "50vh",
                    sm: "50vh",
                    md: "56vh",
                    lg: "60vh",
                    xl: "65vh",
                  },
                  margin: {
                    xs: "0px 0px 0px 1px",
                    sm: "0px 0px 0px 2.5px",
                    md: "0px 0px 0px 2.5px",
                    lg: "0px 0px 0px 2.5px",
                    xl: "0px 0px 0px 2.5px",
                  },
                  padding: {
                    xs: "0px",
                    sm: "0px",
                    md: "0px",
                    lg: "0px",
                    xl: "0px",
                  },
                  gap: 2,
                  maxWidth: {
                    xs: "100%",
                    sm: "90vw",
                    md: "80vw",
                    lg: "70vw",
                    xl: "60vw",
                  },
                }}
              >
                <Paper sx={{ width: '90%', overflow: 'hidden', margin: '10px 0px 0px 45px', border: '1px solid lightgray' }}>
                  <TableContainer sx={{ maxHeight: 450 }}>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow
                          sx={{
                            '& > th': {
                              padding: '2px  10px 2px  10px'
                            }
                          }}
                        >
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{ minWidth: column.minWidth }}
                            >
                              <Typography variant="subtitle1" fontWeight="bold">
                                {column.label}
                              </Typography>
                              <TextField
                                size="small"
                                variant="outlined"
                                placeholder={`Search ${column.label}`}
                                onChange={(e) => handleSearchChange(column.id, e.target.value)}
                                sx={{
                                  mt: 1, margin: '0px', '& .MuiOutlinedInput-input': {
                                    padding: '2px 6px',
                                  },
                                }}

                              />
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {visibleRows
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((row, index) => {
                            return (
                              <TableRow hover role="checkbox" tabIndex={-1} key={row.ResidentDtlId}
                                onDoubleClick={() => handleRowDoubleClick(row.ResidentDtlId)}
                                style={{ cursor: 'pointer' }}
                                sx={{
                                  '& > td': {
                                    padding: '2px  14px 2px  19px',
                                  }
                                }}
                              >
                                {columns.map((column) => {
                                  const value = row[column.id];
                                  return (
                                    <TableCell key={column.id} align={column.align}>
                                      {value}
                                    </TableCell>
                                  );
                                })}

                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 100]}
                    component="div"
                    count={filteredRows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Paper>
              </Box>
            </Grid>
          </DialogTitle>
        </Dialog>

        {/* Image Preview Modal */}
        <Dialog open={openImageModal} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogTitle sx={{ m: 0, p: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box>Document: {selectedImageName}</Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Button size="small" onClick={() => setZoom(prev => Math.max(0.5, prev - 0.25))}>−</Button>
              <Typography variant="body2">{Math.round(zoom * 100)}%</Typography>
              <Button size="small" onClick={() => setZoom(prev => Math.min(3, prev + 0.25))}>+</Button>
              <Button size="small" onClick={() => setZoom(1)} color='error'>Reset</Button>
              <IconButton onClick={handleClose} sx={{ ml: 1 }}>
                <CloseIcon color='error' />
              </IconButton>
            </Box>
          </DialogTitle>

          <DialogContent dividers sx={{ textAlign: 'center', p: 1, overflow: 'auto' }}>
            {selectedImage && (
              <img
                src={selectedImage}
                alt={selectedImageName}
                style={{
                  maxWidth: '100%',
                  maxHeight: '50vh',
                  objectFit: 'contain',
                  borderRadius: '8px',
                  transform: `scale(${zoom})`,
                  transformOrigin: 'center',
                  transition: 'transform 0.2s ease',
                  cursor: zoom < 3 ? 'zoom-in' : 'zoom-out',
                  display: 'block',
                  margin: '0 auto',
                }}
                onClick={() => setZoom(prev => (prev < 3 ? Math.min(3, prev + 0.5) : 1))}
              />
            )}
          </DialogContent>
        </Dialog>
      </Grid>
    </Grid>
  );
};

export default StepperForm;